import {TypeSelector as TypeSelectorComponent} from './TypeSelector.component'
import { connector } from './TypeSelector.connector';
export const TypeSelector = connector(TypeSelectorComponent)
